let zIndex = 1e4;
const overlayZIndexStyles = () => {
  zIndex += 1;
  return {
    zIndex
  };
};
const scrimZIndexStyles = () => ({
  zIndex: zIndex - 1
});
export {
  overlayZIndexStyles,
  scrimZIndexStyles
};
//# sourceMappingURL=utils.mjs.map
